(function($) {

  /* implements object fit polyfil
  @see https://github.com/bfred-it/object-fit-images
  */
  objectFitImages('.img-object-fit');

})(jQuery);
